var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b5175",
    stroke: "#707070",
    d: "M280 77h20v20h-20z",
    "data-name": "Rectangle 17283"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-name": "Mask Group 1416",
    transform: "translate(-280 -77)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M280 77h20v20h-20z",
    "data-name": "Rectangle 17284"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3b5175",
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.583 87 291 91.417a.792.792 0 0 1-.083 1.25.875.875 0 0 1-1.125-.083l-4.958-5a.792.792 0 0 1 0-1.167l4.958-5a.875.875 0 0 1 1.125-.083.792.792 0 0 1 .083 1.249Z",
    "data-name": "Path 21567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.583 87 296 91.417a.792.792 0 0 1-.083 1.25.875.875 0 0 1-1.125-.083l-4.958-5a.792.792 0 0 1 0-1.167l4.958-5a.875.875 0 0 1 1.125-.083.792.792 0 0 1 .083 1.249Z",
    "data-name": "Path 21568"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleArrow);
export default __webpack_public_path__ + "static/media/toggle_arrow.e68c1821c46f9b700ea88804d1b094ec.svg";
export { ForwardRef as ReactComponent };